import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { FilterComponentProps } from "../../../../../types/Tables";
import { useTranslation } from "react-i18next";

const FilterComponent: React.FC<FilterComponentProps> = ({ onFilter, filterText }) => {
  const {t} = useTranslation()
  return (
    <Row className="align-items-center justify-content-end">
      <Col xs="auto">
        <Label>{t("global.search")}:</Label>
      </Col>
      <Col xs="auto" className="d-flex flex-row">
        <Input type="text" value={filterText} onChange={onFilter} placeholder={t("global.searchPlaceholder")} />
      </Col>
    </Row>
  );
};

export default FilterComponent;
